import React from 'react';
export default function ErrorBlock({ error }) {
    if (!error) return null;
    return (
        <div style={{ border: '1px solid #f33', color: '#900', padding: 12, borderRadius: 10, margin: '12px 0' }}>
            <b>Ошибка</b>
            <div style={{ whiteSpace: 'pre-wrap' }}>{String(error)}</div>
        </div>
    );
}
